<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import * as apis from '/@src/client-portal/api'
import FileDownload from 'js-file-download'
import { inject, Ref, ref, watch } from 'vue'
import { useNotyf } from '/@src/composable/useNotyf'
import slugify from '@sindresorhus/slugify'
import { useRoute } from 'vue-router'
import { useSteps } from '/@src/composable/useSteps'
import { NazvyKrokov } from '/@src/utils/zoppm/types'

const { t } = useI18n()
const { activeStep } = useSteps()
const portalZoppm = new apis.ZoppmReportApi()
const zoppmApi = new apis.PortalZoppmApi()
const zoppmPortalApi = new apis.PortalZoppmApi()
const loading = ref<boolean>(false)
const notyf = useNotyf()
const kodIrz = inject<Ref<string>>('kodIrz')
const route = useRoute()
const result = ref<any>()
const isGenerated = ref<boolean>(true)

async function downloadZiadost() {
  loading.value = true
  await checkIfPdfGenerated()
  const zoppmId = localStorage.getItem('zoppmId')

  let kodProjektu = ''
  await zoppmPortalApi.getZoppmPortalZoppm(zoppmId as string).then((response) => {
    kodProjektu = response.data.data?.projekt?.projektRef?.kod as string
  })

  try {
    if (zoppmId) {
      await portalZoppm
        .getZoppmPdfReportZoppmReport(zoppmId, { responseType: 'blob' })
        .then((response) => {
          FileDownload(
            response.data,
            `Ziadost_${slugify(
              kodProjektu ? kodProjektu : kodIrz?.value || response.headers.filename
            )}.pdf`
          )
        })
    }
  } catch (err: any) {
    console.trace(err)
    notyf.error(t('globalne.chybaNacitaniaDat'))
  } finally {
    loading.value = false
  }
}

const checkIfPdfGenerated = async () => {
  isGenerated.value = false
  try {
    while (!isGenerated.value) {
      let response = await zoppmPortalApi.isPdfGeneratedPortalZoppm(
        <string>localStorage.getItem('zoppmId')
      )
      isGenerated.value = response.data
      if (isGenerated.value) {
        return true
      }
      await new Promise((resolve) => setTimeout(resolve, 200))
    }
  } catch (error) {
    notyf.warning('Došlo k chybe siete')
    return false
  }
}

watch(
  () => activeStep.value,
  async (current) => {
    if (current === NazvyKrokov['sposobPodaniaZiadostiNaPosudenie']) {
      try {
        result.value = await zoppmApi.getZoppmPortalZoppm(
          <string>localStorage.getItem('zoppmId')
        )
      } catch (error) {
        notyf.warning('Nastala chyba pri sťahovaní údajov o ŽoPPM')
      }
    }
  }
)
</script>

<template>
  <IDSKContainer>
    <IDSKParagraph>
      {{ t('zoppm.step17.textacia.p1') }}
    </IDSKParagraph>
    <IDSKParagraph>{{ t('zoppm.step17.textacia.p2') }}</IDSKParagraph>
    <IDSKParagraph>
      {{ t('zoppm.step17.textacia.p3') }} <b>{{ result?.data?.ref?.kod }}</b>
    </IDSKParagraph>
    <IDSKParagraph class="mb-9">
      {{ t('zoppm.step17.textacia.p4') }}
      <IDSKRouterLink :href="`/app/vyzvy/${route.query.vyzvaId}`">{{
        t('zoppm.step17.textacia.tenderLink')
      }}</IDSKRouterLink>
    </IDSKParagraph>
    <IDSKButton
      :disabled="loading || !isGenerated"
      class="mr-5"
      type="button"
      :data-test-id="`zoppm-sposob-podania-stiahnut-ziadost`"
      @click="downloadZiadost"
    >
      {{ t('zoppm.step17.stiahnutZiadost') }}
      <LoadingSpinner v-show="loading" />
    </IDSKButton>
  </IDSKContainer>
</template>

<style scoped lang="scss"></style>
